var React = require('react');

function PopulationDashboard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M57 0H11C4.9 0 0 4.9 0 11v23.1c0 6.1 4.9 11 11 11h11.5L20.7 56h-4.1c-1.1 0-2 0.9-2 2s0.9 2 2 2h5.8 23.3 5.8c1.1 0 2-0.9 2-2s-0.9-2-2-2h-4.1l-1.8-10.9H57c6.1 0 11-4.9 11-11V11C68 4.9 63.1 0 57 0zM24.7 56l1.7-10h15.2l1.7 10H24.7zM64 34.1c0 3.9-3.1 7-7 7H11c-3.9 0-7-3.1-7-7V11c0-3.9 3.1-7 7-7h46c3.9 0 7 3.1 7 7V34.1z","key":0}),React.createElement("path",{"d":"M56.6 20.5H50l-6.9-10c-0.6-0.9-1.6-1.3-2.7-1.3 -1.1 0.1-2 0.7-2.5 1.6L27.4 31 21 21.9c-0.6-0.8-1.5-1.3-2.5-1.3H9.6c-1.1 0-2 0.9-2 2s0.9 2 2 2H18l6.9 10c0.6 0.8 1.5 1.3 2.5 1.3 0.1 0 0.1 0 0.2 0 1.1-0.1 2-0.7 2.6-1.6l10.4-20.1 6.3 9.1c0.6 0.8 1.5 1.3 2.5 1.3h7.1c1.1 0 2-0.9 2-2S57.7 20.5 56.6 20.5z","key":1})]);
}

PopulationDashboard.defaultProps = {"viewBox":"0 0 68 60"};

module.exports = PopulationDashboard;

PopulationDashboard.default = PopulationDashboard;
